export const FETCH_DATE_FILE_SUCCESS = 'FETCH_DATE_FILE_SUCCESS'
export const FETCH_DATE_FILE_ERROR = 'FETCH_DATE_FILE_ERROR'
export const FETCH_FILE_SUCCESS = 'FETCH_FILE_SUCCESS'
export const FETCH_FILE_ERROR = 'FETCH_FILE_ERROR'

export const FETCH_USER_FILES_REQUEST = 'FETCH_USER_FILES_REQUEST'
export const FETCH_USER_FILES_SUCCESS = 'FETCH_USER_FILES_SUCCESS'
export const FETCH_USER_FILES_ERROR = 'FETCH_USER_FILES_ERROR'

export const OPEN_SECOND_PASSWORD_MODAL = 'OPEN_SECOND_PASSWORD_MODAL'
export const CLOSE_SECOND_PASSWORD_MODAL = 'CLOSE_SECOND_PASSWORD_MODAL'

export const SIGN_DOCUMENT_REQUEST = 'SIGN_DOCUMENT_REQUEST'
export const SIGN_DOCUMENT_SUCCESS = 'SIGN_DOCUMENT_SUCCESS'
export const SIGN_DOCUMENT_ERROR = 'SIGN_DOCUMENT_ERROR'

export const FINISH_SIGNING_PROCESS_REQUEST = 'FINISH_SIGNING_PROCESS_REQUEST'
export const FINISH_SIGNING_PROCESS_SUCCESS = 'FINISH_SIGNING_PROCESS_SUCCESS'
export const FINISH_SIGNING_PROCESS_ERROR = 'FINISH_SIGNING_PROCESS_ERROR'

export const GET_SECOND_PASSWORD_REQUEST = 'GET_SECOND_PASSWORD_REQUEST'
export const GET_SECOND_PASSWORD_SUCCESS = 'GET_SECOND_PASSWORD_SUCCESS'
export const GET_SECOND_PASSWORD_ERROR = 'GET_SECOND_PASSWORD_ERROR'

export const UPLOAD_FILE_TED_SUCCESS = 'UPLOAD_FILE_TED_SUCCESS'
export const UPLOAD_FILE_TED_ERROR = 'UPLOAD_FILE_TED_ERROR'
export const UPLOADING_FILE_TED = 'UPLOADING_FILE_TED'
export const CLEAN_ERROR_TED = 'CLEAN_ERROR_TED'

export const SECOND_PASSWORD_RETRY = 'SECOND_PASSWORD_RETRY'
export const SECOND_PASSWORD_RETRY_RESET = 'SECOND_PASSWORD_RETRY_RESET'

export const FETCH_DECLARACION_JURADA_REQUEST = 'FETCH_DECLARACION_JURADA_REQUEST'
export const FETCH_DECLARACION_JURADA_SUCCESS = 'FETCH_DECLARACION_JURADA_SUCCESS'
export const FETCH_DECLARACION_JURADA_ERROR = 'FETCH_DECLARACION_JURADA_ERROR'

export const FETCH_SENDPDF_DECLARACION_JURADA_REQUEST = 'FETCH_SENDPDF_DECLARACION_JURADA_REQUEST'
export const FETCH_SENDPDF_DECLARACION_JURADA_SUCCESS = 'FETCH_SENDPDF_DECLARACION_JURADA_SUCCESS'
export const TESTDOCUMENT = 'TESTDOCUMENT'
